import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100 py-5 px-10 position-relative bg-secondary" }
const _hoisted_2 = { class: "row justify-content-between" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-4 order-1 text-center d-flex justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-2 fw-bold text-center col-lg-4 col-md-6 col-8 order-2 mb-0" }, " Vende tu vehículo ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "col-lg-4 order-3" }, null, -1)
const _hoisted_6 = { class: "bg-transparent card col-lg-4 col-md-8 col-sm-12 border-1 border-secondary rounded mx-auto my-10 p-10 border border-gray" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "pb-10 pb-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold text-dark text-center" }, " Recibe una oferta por tu vehículo ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-content-center my-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "80",
    src: "media/images/IsotipoSolana.svg",
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_11 = { class: "text-white fw-bold fs-5 text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-center my-7" }, "Te podemos ofertar", -1)
const _hoisted_13 = { class: "fs-1 fw-bold text-success text-center mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-gray fs-xs" }, " Esta oferta es aproximada y podría cambiar al momento de hacer la revisión ", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "pb-10 pb-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-content-center my-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "80",
    src: "media/images/IsotipoSolana.svg",
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_18 = { class: "text-white fw-bold fs-5 text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white fs-base mt-10 w-75 mx-auto" }, " Por el momento no contamos con citas en tu ciudad, nos pondremos en contacto contigo para conocer más de tu vehículo. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold text-dark text-center" }, " Dudas o aclaraciones ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-center my-7" }, "Te podemos ofertar", -1)
const _hoisted_22 = { class: "fs-1 fw-bold text-success text-center mb-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-gray fs-xs" }, " Esta oferta es aproximada y podría cambiar al momento de hacer la revisión ", -1)
const _hoisted_24 = { class: "row flex-column align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-2 fw-bold my-4 text-center" }, "Dudas o aclaraciones", -1)
const _hoisted_26 = ["href"]
const _hoisted_27 = ["href"]
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "pb-10 pb-lg-15" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold text-dark text-center" }, "Sin cupos disponibles", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-content-center my-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "80",
    src: "media/images/IsotipoSolana.svg",
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_32 = { class: "text-white fw-bold fs-5 text-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white fs-base mt-10 w-75 mx-auto" }, " Por el momento no contamos con citas en tu ciudad, nos pondremos en contacto contigo para conocer más de tu vehículo. ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bold text-center mb-10" }, "Dudas o aclaraciones", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-center my-7" }, "Te podemos ofertar", -1)
const _hoisted_37 = { class: "fs-1 fw-bold text-success text-center mb-10" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-gray fs-xs" }, " Esta oferta es aproximada y podría cambiar al momento de hacer la revisión ", -1)
const _hoisted_39 = { class: "row flex-column align-items-center" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { class: "pb-10 pb-lg-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold text-dark text-center" }, " Recibe una oferta por tu vehículo ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-content-center my-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "80",
    src: "media/images/IsotipoSolana.svg",
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_46 = { class: "text-white fw-bold fs-5 text-center" }
const _hoisted_47 = { class: "text-center text-white fs-base mt-10 w-75 mx-auto" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)
const _hoisted_50 = { class: "row flex-column align-items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-2 fw-bold my-4 text-center" }, "Dudas o aclaraciones", -1)
const _hoisted_52 = ["href"]
const _hoisted_53 = ["href"]
const _hoisted_54 = {
  key: 4,
  ref: "valuateVehicle",
  class: "stepper stepper-links d-flex flex-column",
  id: "valuate_form"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-nav m-0 d-none" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "stepper-item current",
    "data-kt-stepper-element": "nav"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "stepper-item",
    "data-kt-stepper-element": "nav"
  })
], -1)
const _hoisted_56 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "col-lg-12" }
const _hoisted_59 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Escoge la marca", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Marca")
], -1)
const _hoisted_62 = { class: "position-relative" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "col-lg-12" }
const _hoisted_66 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Escoge el modelo", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Modelo")
], -1)
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Escoge el año del vehículo", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Año", -1)
const _hoisted_75 = { class: "position-relative" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "col-12" }
const _hoisted_79 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Escoge la versión", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Versión", -1)
const _hoisted_82 = { class: "position-relative" }
const _hoisted_83 = { class: "fv-plugins-message-container" }
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = { class: "col-12" }
const _hoisted_86 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Indica el kilometraje", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label my-2" }, "Kilometraje aproximado", -1)
const _hoisted_89 = { class: "position-relative" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "col-12" }
const _hoisted_93 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold my-3 text-center" }, "Dueños", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label my-2" }, "Indica la cantidad que ha tenido", -1)
const _hoisted_96 = { class: "position-relative" }
const _hoisted_97 = { class: "fv-plugins-message-container" }
const _hoisted_98 = { class: "fv-help-block" }
const _hoisted_99 = { "data-kt-stepper-element": "content" }
const _hoisted_100 = { class: "w-100" }
const _hoisted_101 = { class: "pb-6" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2 fw-bold text-dark text-center" }, " Recibe una oferta por tu vehículo ", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-content-center my-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "80",
    src: "media/images/IsotipoSolana.svg",
    class: "mx-auto",
    alt: "logo"
  })
], -1)
const _hoisted_104 = { class: "text-white fs-5 fw-bold text-center mb-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fs-5 fw-bold mt-2 mb-1" }, " Ingresa tus datos para continuar ")
], -1)
const _hoisted_106 = {
  class: "row",
  "data-kt-buttons": "true"
}
const _hoisted_107 = { class: "col-lg-6" }
const _hoisted_108 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nombre")
], -1)
const _hoisted_110 = { class: "position-relative" }
const _hoisted_111 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_112 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_113 = { class: "fv-plugins-message-container" }
const _hoisted_114 = { class: "fv-help-block" }
const _hoisted_115 = { class: "col-lg-6" }
const _hoisted_116 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Apellidos")
], -1)
const _hoisted_118 = { class: "fv-plugins-message-container" }
const _hoisted_119 = { class: "fv-help-block" }
const _hoisted_120 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Correo electrónico", -1)
const _hoisted_122 = { class: "position-relative" }
const _hoisted_123 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_124 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_125 = { class: "fv-plugins-message-container" }
const _hoisted_126 = { class: "fv-help-block" }
const _hoisted_127 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Teléfono", -1)
const _hoisted_129 = { class: "position-relative" }
const _hoisted_130 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_131 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_132 = { class: "fv-plugins-message-container" }
const _hoisted_133 = { class: "fv-help-block" }
const _hoisted_134 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold form-label mb-2" }, "Ciudad", -1)
const _hoisted_136 = { class: "fv-plugins-message-container" }
const _hoisted_137 = { class: "fv-help-block" }
const _hoisted_138 = { class: "d-flex flex-stack pt-3" }
const _hoisted_139 = { class: "col-12" }
const _hoisted_140 = {
  ref: "submitButtonRef",
  type: "submit",
  class: "btn btn-lg btn-primary w-100"
}
const _hoisted_141 = { class: "indicator-label fs-base" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Enviando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            role: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returned())),
            class: "svg-icon svg-icon-1hx pointer fs-base"
          }, _toDisplayString("❮ Regresar"))
        ]),
        _hoisted_4,
        _hoisted_5
      ])
    ]),
    _createVNode(_component_el_progress, {
      percentage: _ctx.statusBar,
      "show-text": false,
      color: "primary"
    }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_loaderClientVue, { showLoader: _ctx.showLoader }, null, 8, ["showLoader"]),
      (_ctx.next_step == 'success_valuation' && _ctx.has_agency)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.brand && _ctx.brand.name) + " | " + _toDisplayString(_ctx.model && _ctx.model.name) + " | " + _toDisplayString(_ctx.versionText) + " | " + _toDisplayString(_ctx.year && _ctx.year.name), 1),
              _hoisted_12,
              _createElementVNode("h1", _hoisted_13, "$" + _toDisplayString(_ctx.priceFormat(_ctx.valuation)), 1),
              _hoisted_14,
              (_ctx.has_agency)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/agendar-cita",
                    class: "btn btn-primary w-100 fs-base"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Agendar cita")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.next_step == 'success_valuation' && !_ctx.has_agency)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.brand && _ctx.brand.name) + " | " + _toDisplayString(_ctx.model && _ctx.model.name) + " | " + _toDisplayString(_ctx.versionText) + " | " + _toDisplayString(_ctx.year && _ctx.year.name), 1),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _createElementVNode("h1", _hoisted_22, "$" + _toDisplayString(_ctx.priceFormat(_ctx.valuation)), 1),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("a", {
                  href: `mailto:${_ctx.contact_data.email}`,
                  class: "text-white mt-5 fs-base text-center"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/Correo sobre-sms.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.contact_data.email), 1)
                ], 8, _hoisted_26),
                _createElementVNode("a", {
                  href: `tel:${_ctx.contact_data.phone}`,
                  class: "text-white mb-10 mt-2 text-center fs-base"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/call.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.phoneFormat(_ctx.contact_data.phone)), 1)
                ], 8, _hoisted_27),
                _createVNode(_component_router_link, {
                  to: "/home",
                  class: "btn btn-primary w-100 fs-base"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Regresar al inicio")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.next_step == 'with_out_dates')
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.brand && _ctx.brand.name) + " | " + _toDisplayString(_ctx.model && _ctx.model.name) + " | " + _toDisplayString(_ctx.versionText) + " | " + _toDisplayString(_ctx.year && _ctx.year.name), 1),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              (_ctx.valuation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_36,
                    _createElementVNode("h1", _hoisted_37, " $" + _toDisplayString(_ctx.priceFormat(_ctx.valuation)), 1),
                    _hoisted_38
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("a", {
                  href: `mailto:${_ctx.contact_data.email}`,
                  class: "text-white mt-5 fs-base text-center"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/Correo sobre-sms.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.contact_data.email), 1)
                ], 8, _hoisted_40),
                _createElementVNode("a", {
                  href: `tel:${_ctx.contact_data.phone}`,
                  class: "text-white mb-10 mt-2 text-center fs-base"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/call.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.phoneFormat(_ctx.contact_data.phone)), 1)
                ], 8, _hoisted_41)
              ]),
              _createVNode(_component_router_link, {
                to: "/home",
                class: "btn btn-primary w-100 fs-base"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Regresar al inicio")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.next_step == 'valuation_zero')
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.brand && _ctx.brand.name) + " | " + _toDisplayString(_ctx.model && _ctx.model.name) + " | " + _toDisplayString(_ctx.versionText) + " | " + _toDisplayString(_ctx.year && _ctx.year.name), 1),
              _createElementVNode("p", _hoisted_47, [
                _createTextVNode(" Por el momento no contamos con oferta, "),
                (!_ctx.has_agency)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "ni cupos"))
                  : _createCommentVNode("", true),
                _createTextVNode(" para tu vehículo, nos pondremos en contacto contigo para poder darte una propuesta. ")
              ]),
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("a", {
                  href: `mailto:${_ctx.contact_data.email}`,
                  class: "text-white mt-5 fs-base text-center"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/Correo sobre-sms.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.contact_data.email), 1)
                ], 8, _hoisted_52),
                _createElementVNode("a", {
                  href: `tel:${_ctx.contact_data.phone}`,
                  class: "text-white mb-10 mt-2 text-center fs-base"
                }, [
                  _createVNode(_component_inline_svg, {
                    class: "w-20px h-20px",
                    src: "media/icons/iconsax/call.svg"
                  }),
                  _createTextVNode("   " + _toDisplayString(_ctx.phoneFormat(_ctx.contact_data.phone)), 1)
                ], 8, _hoisted_53)
              ]),
              (_ctx.has_agency)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/agendar-cita",
                    class: "btn btn-primary w-100 fs-base"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Agendar cita")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/home",
                    class: "btn btn-primary w-100 fs-base"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regresar al inicio")
                    ]),
                    _: 1
                  }))
            ])
          ]))
        : (!_ctx.showSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("form", {
                class: "mx-auto mw-600px w-100",
                novalidate: "novalidate",
                id: "form_valuate",
                ref: "formRef",
                onSubmit: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_Field, {
                            name: "brand",
                            autocomplete: "off",
                            class: "form-select form-select-solid select2-hidden-accessible",
                            modelValue: _ctx.formData.brand,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.brand) = $event))
                          }, {
                            default: _withCtx(({ value, errorMessage, handleChange }) => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                name: "brand",
                                value: value,
                                "model-value": value,
                                "onUpdate:modelValue": handleChange,
                                loading: _ctx.loading,
                                size: "large",
                                onChange: _ctx.getModels
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "Selecciona una marca",
                                    selected: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Selecciona una marca")
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_ErrorMessage, { name: "brand" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _hoisted_68,
                        _createVNode(_component_Field, {
                          name: "model",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          modelValue: _ctx.formData.model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.model) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              name: "model",
                              value: value,
                              "model-value": value,
                              "onUpdate:modelValue": handleChange,
                              loading: _ctx.loading,
                              size: "large",
                              onChange: _ctx.getYears
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "Selecciona un modelo",
                                  selected: true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Selecciona un modelo")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_ErrorMessage, { name: "model" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _hoisted_74,
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_component_Field, {
                            name: "year",
                            autocomplete: "off",
                            class: "form-select form-select-solid select2-hidden-accessible",
                            modelValue: _ctx.formData.year,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.year) = $event))
                          }, {
                            default: _withCtx(({ value, errorMessage, handleChange }) => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                name: "year",
                                value: value,
                                "model-value": value,
                                "onUpdate:modelValue": handleChange,
                                loading: _ctx.loading,
                                size: "large",
                                onChange: _ctx.getVersions
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "Selecciona un año",
                                    selected: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Selecciona un año")
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_ErrorMessage, { name: "year" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _hoisted_81,
                        _createElementVNode("div", _hoisted_82, [
                          _createVNode(_component_Field, {
                            name: "version",
                            autocomplete: "off",
                            class: "form-select form-select-solid select2-hidden-accessible",
                            modelValue: _ctx.formData.version,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.version) = $event))
                          }, {
                            default: _withCtx(({ value, errorMessage, handleChange }) => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                name: "version",
                                value: value,
                                "model-value": value,
                                "onUpdate:modelValue": handleChange,
                                loading: _ctx.loading,
                                size: "large",
                                onChange: _ctx.setVersion
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "Selecciona una versión",
                                    selected: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Selecciona una versión")
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createVNode(_component_ErrorMessage, { name: "version" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _hoisted_88,
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "km",
                            ref: "km",
                            autocomplete: "off",
                            class: "form-control form-control-solid fs-base border-1 border-secondary",
                            placeholder: "000,000 km",
                            modelValue: _ctx.formData.km,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.km) = $event)),
                            onChange: _ctx.addKm
                          }, null, 8, ["modelValue", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createVNode(_component_ErrorMessage, { name: "km" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _hoisted_94,
                        _hoisted_95,
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_el_input_number, {
                            class: "w-100 in-num",
                            modelValue: _ctx.formData.owners,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.owners) = $event)),
                            name: "owners",
                            min: 1,
                            max: 10
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createVNode(_component_ErrorMessage, { name: "owners" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _hoisted_103,
                      _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.brand && _ctx.brand.name) + " | " + _toDisplayString(_ctx.model && _ctx.model.name) + " | " + _toDisplayString(_ctx.version && _ctx.version.name) + " | " + _toDisplayString(_ctx.year && _ctx.year.name), 1),
                      _hoisted_105
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("div", _hoisted_110, [
                            _createVNode(_component_Field, {
                              type: "text",
                              autocomplete: "off",
                              class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                              placeholder: "Luis Daniel",
                              name: "name",
                              modelValue: _ctx.formData.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.name) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("span", _hoisted_112, [
                                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/user.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _createVNode(_component_ErrorMessage, { name: "name" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _hoisted_117,
                          _createVNode(_component_Field, {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-solid border-1 fs-base border-secondary ps-5",
                            placeholder: "Anaya Diaz",
                            name: "last_name",
                            modelValue: _ctx.formData.last_name,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.last_name) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("div", _hoisted_119, [
                              _createVNode(_component_ErrorMessage, { name: "last_name" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_120, [
                        _hoisted_121,
                        _createElementVNode("div", _hoisted_122, [
                          _createVNode(_component_Field, {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                            placeholder: "example@mail.com",
                            name: "email",
                            modelValue: _ctx.formData.email,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.email) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("span", _hoisted_124, [
                              _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("div", _hoisted_126, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _hoisted_128,
                        _createElementVNode("div", _hoisted_129, [
                          _withDirectives(_createVNode(_component_Field, {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                            placeholder: "333-333-3331",
                            name: "phone",
                            modelValue: _ctx.formData.phone,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.phone) = $event))
                          }, null, 8, ["modelValue"]), [
                            [_directive_maska, { mask: 'Z##-###-####', tokens: { Z: { pattern: /[1-9]/ } } }]
                          ]),
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("span", _hoisted_131, [
                              _createVNode(_component_inline_svg, { src: "media/icons/iconsax/call.svg" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _createVNode(_component_ErrorMessage, { name: "phone" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_134, [
                        _hoisted_135,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "fs-base",
                          name: "city",
                          modelValue: _ctx.formData.city,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.city) = $event))
                        }, {
                          default: _withCtx(({value}) => [
                            _createVNode(_component_AutoComplete, {
                              name: "city",
                              onCityValue: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cityValuemit($event)))
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("div", _hoisted_137, [
                            _createVNode(_component_ErrorMessage, { name: "city" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("button", _hoisted_140, [
                      _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.currentStepIndex === 0 ? "Obtener una oferta" : "Enviar mis datos"), 1),
                      _hoisted_142
                    ], 512)
                  ])
                ])
              ], 544)
            ], 512))
          : _createCommentVNode("", true)
    ])
  ], 64))
}